<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div v-if="userId == 1" class="select-box">
      <div class="select-label">查看用户小程序:</div>
      <Select v-model="userInfoId" style="width:100px" clearable @on-clear="clearUserId" @on-change="changeUserId">
        <Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </div>
    <div class="select-box input_left" :style="{left:userId != 1?'207px':''} ">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入小程序名称" :rows="4" />
    </div>
    <div class="select-box input_left_two" :style="{left:userId != 1?'380px':''} ">
      <Input v-model="searchAppVer" style="width:150px;" placeholder="请输入版本号" :rows="4" />
    </div>
    <div class="select-box input_left_three" :style="{left:userId != 1?'550px':''} ">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
      <Button type="primary" @click="newAlert" style="margin-left:10px;">添加新应用</Button>
    </div>
    <div class="select-box-type">
      <Select v-model="tableType" style="width:100px" @on-change="changeTableType">
        <Option :value="0" key="0">图标</Option>
        <Option :value="1" key="1">列表</Option>
      </Select>
    </div>
    <Scroll style="margin-top:20px;" v-show="tableType === 0" :height="scrollHeight" :on-reach-bottom="handleReachBottom">
    <div class="app-list">
       <div v-if="isShowSpin" class="card-spin-container">
          <Spin fix></Spin>
      </div>
      <Card class="app-item">
        <div class="app-add" @click="newAlert">
          <Icon type="md-add" size="100" />
          <p>添加新应用</p>
        </div>
      </Card>
      <Card class="app-item" :id="'scroll' + item.id" v-for="(item, index) in dataList" :key="index">
        <div class="text-center">
          <div class="app-info">
            <img :src="item.icon">
            <h3>{{item.name}}</h3>
            <p><strong style="color: #19be6b">{{item.package_stats}}</strong> {{item.package_ver}}</p>
            <p>{{item.update_at}}</p>
            <Tag color="primary" class="app_aduit_stats">{{aduitText(item.aduit_stats)}}</Tag>
            <Tag :color="item.state === 1 ? 'primary' : 'warning'" class="app_close_stats">{{item.state === 1 ? '已启用' : '未启用'}}</Tag>
          </div>
          <div class="app-option" style="overflow:hidden">
            <div class="option-item" v-if="item.uid === userId" @click="newAlert(index)">
              <div class="item-icon"><Icon size="25" type="md-create" /></div>
              <p>编辑</p>
            </div>
            <div class="option-item" @click="gotoScroll(item)" :to="{name: 'versionTest', query: {tvid: item.id, icon: item.icon, name: item.name, package_name: item.package_name, id: item.id}}">
              <div class="item-icon"><Icon size="25" type="md-cloud-upload" /></div>
              <p>版本管理</p>
            </div>
            <div v-if="userAccount.id !== 1">
              <Button type="primary" v-show="item.payment_status === 0" @click="applyPayAlert(index)">申请支付功能</Button>
              <Button type="primary" v-show="item.payment_status === 1" :disabled="true">支付功能申请中...</Button>
              <Button type="primary" v-show="item.payment_status === 2" @click="copyStr(item.pay_key)">复制：{{item.pay_key}}</Button>
              <Button type="primary" v-show="item.payment_status === 3" @click="applyPayAlert(index)">重新申请支付功能</Button>
            </div>
            <input type="text" id="copyinput"/>
          </div>
        </div>
      </Card>
    </div>
    </Scroll>
    <div class="app-list-table" v-show="tableType === 1">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    <div v-for="(item,index) in batchErrArr" :key="index">
      {{item.name}}---{{item.message}}
    </div>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :footer-hide="editFlag === 'true'?true:false"
      :title="editId ? editFlag === 'true' ? '查看应用' : '编辑应用' : '新建应用'"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="应用名称" prop="name">
          <Input v-model="formValidate.name" :disabled="editFlag === 'true'" placeholder="请输入应用名称，2-20个字" />
        </FormItem>
        <FormItem label="应用包名" prop="package_name" :rules="[{ required: !editId, message: '请输入应用包名', trigger: 'blur' }]">
          <Input v-model="formValidate.package_name" :disabled="editFlag === 'true'" :readonly="!!editId" placeholder="请输入小程序包名" />
          <div class="tips">应用包名创建后不可修改，例如es.huxiaobao.vip。</div>
        </FormItem>
        <FormItem label="小程序Icon" prop="fileName" :rules="[{required: !editId, message: '请上传小程序Icon', trigger: 'blur'}]">
          <label class="file-wrap">
            <input class="file-input" type="file" ref="file" accept="image/*" @change="uploadImg('file')" />
            <Button :disabled="editFlag === 'true'" icon="ios-cloud-upload-outline">{{formValidate.fileName || '上传'}}</Button>
          </label>
          <div><img v-show="formValidate.icon" :src="formValidate.icon" width="300"></div>
        </FormItem>
        <FormItem v-show="editId" label="最低可用版本" prop="min_ver">
          <Select
                v-model="formValidate.min_ver"
                placeholder="请选择版本"
                filterable
                :disabled="editFlag === 'true'"
                >
                <Option v-for="(option, index) in minVerList" :value="option.package_ver" :tag="option" :key="index">{{option.package_ver}}</Option>
            </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" :disabled="editFlag === 'true'" type="textarea" :rows="4" />
        </FormItem>
        <FormItem v-if="formValidate.aduit_stats === 3" label="未通过原因" prop="aduit_con">
          <Input v-model="formValidate.aduit_con" :disabled="editFlag === 'true'" readonly type="textarea" :rows="4" />
        </FormItem>
        <div class="option-item" v-if="formValidate.aduit_stats === 2" style="margin-left:24px;">
              <div class="option-top">
                应用是否启用:
                <i-switch :disabled="editFlag === 'true'" :value="formValidate.state === 1" @on-change="switchChange" true-color="#13ce66" />
              </div>
            </div>
        <Button v-if="editId" :disabled="editFlag === 'true'" type="primary" style="margin-left:236px;" @click="delCurrentApp">删除当前应用</Button>
      </Form>
    </Modal>

    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowApplyPay"
      title="完善支付相关信息"
      @on-ok="applyData('formPayValidate')">
      <Form ref="formPayValidate" :model="formPayValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="应用名称" prop="apk_name">
          <Input v-model="formPayValidate.apk_name" placeholder="请输入商店上架应用名称，2-20个字" />
        </FormItem>
        <FormItem label="小程序包名" prop="app_pkg">
          <Input v-model="formPayValidate.app_pkg" :disabled="true" placeholder="请输入小程序包名，创建后不可修改。需以es. 开头，例如tv.huan.vibes.test" />
        </FormItem>
        <FormItem label="商店上架包名" prop="apk_pkg">
          <Input v-model="formPayValidate.apk_pkg" :disabled="appPkgFlag" placeholder="商店上架包名,例如tv.huan.vibes.test" />
          <div class="tips">提示小程序包名创建后不可修改，仅支持小写英文，需遵循三段或以上分段式</div>
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="800"
      :mask-closable="false"
      v-model="isShowAgreement"
      title=""
      :footer-hide="true"
      >
      <div class="agreement_title">分成协议</div>
      <div class="agreement_text">
        <!-- 55分成XXX协55分成XXX协议55分成XXX协议55分成XXX协
        议55分成XXX协议55分成XXX协议55分成XXX协议55分成XX
        X协议55分成XXX协议55分成XXX协议55分成XXX协议55分成XX -->
      </div>
      <div style="margin-left:300px;">
        <Checkbox  v-model="single">已阅读并同意协议中的内容</Checkbox>
      <Button type="primary" :disabled="!single" @click="checkAgreement">签署该协议并申请开通支付</Button></div>
    </Modal>
    <!-- isShowAgreement -->

  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      tableType: 0,
      mobileApp: [],
      editId: '',
      editItem: '',
      userId: '',
      userList: [],
      userInfoId: '',
      searchAppName: '',
      searchAppVer: '',
      currentIndex: '',
      isShowApplyPay: false,
      isShowAgreement: false,
      single: false,
      isShowSpin: false,
      userAccount: {},
      tableSelectRow: [],
      batchErrArr: [],
      batchErrArrFlag: false,
      editFlag: 'false',
      formValidatePl: {
        ver: ''
      },
      formValidate: {
        name: '',
        remark: '',
        package_name: '',
        icon: '',
        files: '',
        fileName: '',
        pre_pwd: ''
      },
      minVerList: [],
      formPayValidate: {
        app_pkg: '',
        apk_name: '',
        apk_pkg: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 20, min: 2, message: '请输入2-20个字', trigger: 'blur' }
        ],
        pre_pwd: [
          { required: false, message: '请输入预览密码', trigger: 'blur' },
          { type: 'string', max: 32, message: '长度最多32位', trigger: 'blur' }
        ],
        // apk_pkg: { required:true,pattern:/^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g , message:'示例：tv.huan.vibes.test。' }
        apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '应用名称',
          key: 'name',
          width: 150,
          align: 'center'
        },
        {
          title: 'icon',
          key: 'icon',
          width: 90,
          render: (h, params) => {
            return h('img', {attrs: {
              src: params.row.icon
            },
            style: {
              width: '50px',
              height: '50px',
              marginTop: '10px'
            }
            })
          }
        },
        // {
        //   title: '审核状态',
        //   key: 'aduit_stats',
        //   width: 200,
        //   render: (h, params) => {
        //     let aduit_stats = ''
        //     switch (params.row.aduit_stats) {
        //       case 0:
        //         aduit_stats = '未提审'
        //         break
        //       case 1:
        //         aduit_stats = '待审核'
        //         break
        //       case 2:
        //         aduit_stats = '审核通过'
        //         break
        //       case 3:
        //         aduit_stats = '审核驳回'
        //         break
        //     }
        //     let html = [
        //       h('span', aduit_stats)
        //     ]
        //     return html
        //   }
        // },
        {
          title: '包名',
          key: 'package_name',
          width: 200
        },
        {
          title: '最新版本',
          key: 'package_ver',
          align: 'center',
          width: 150
        },
        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          minWidth: 150
        },
        {
          title: '最后更新时间',
          key: 'updated_at',
          align: 'center',
          minWidth: 150
        },
        {
          title: '操作',
          width: 320,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.uid !== this.userId)
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'edit')
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index, 'look')
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  width: '70px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.setTableType()
                    this.$router.push({
                      path: `/developer/versionTest`,
                      query: {
                        tvid: params.row.id,
                        icon: params.row.icon,
                        name: params.row.name,
                        table: this.tableType,
                        package_name: params.row.package_name,
                        id: params.row.id,
                        uid: params.row.uid
                      }
                    })
                  }
                }
              }, '版本管理')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     width: '70px',
              //     marginRight: '10px'
              //   },
              //   on: {
              //     click: () => {
              //       this.applyPayAlert(params.index)
              //     }
              //   }
              // }, '支付申请'),
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     width: '50px',
              //     marginRight: '10px'
              //   },
              //   on: {
              //     click: () => {
              //       this.delItem(params.index)
              //     }
              //   }
              // }, '删除')
            ])
          }
        }
      ],
      mobileData: {
        id: '',
        name: '',
        app_rel: []
      },
      appPkgFlag: false,
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 40, // 每页多少条
      current: 1, // 当前页
      t1: 0,
      t2: 0,
      timer: null,
      scrollHeight: 600
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.role_id = window.localStorage.getItem('role_id')
    this.userId = Number(window.localStorage.getItem('userId'))
    this.tableType = Number(sessionStorage.getItem('tableType'))
    if (this.tableType === 1) {
      this.pageSize = 10
    }
    this.getUserList()
    this.getAccount()
    // this.getQualification().then(this.loadData)
    this.loadData()
    this.handleElementHeight()
  },
  mounted () {
    setTimeout(() => {
      let scroll_top_xy = sessionStorage.getItem('scroll_top_apk')
      if (scroll_top_xy) {
        let oA = document.createElement('a')
        oA.href = '#scroll' + scroll_top_xy
        oA.click()
      }
    }, 100)
  },
  methods: {
    handleElementHeight () {
      const scrollbarHeight = document.documentElement.clientHeight
      this.scrollHeight = (scrollbarHeight - 246)
    },
    handleReachBottom () {
      return new Promise(resolve => {
        // setTimeout(() => {
        this.current = this.current + 1
        this.loadData('reach')
        resolve()
        // }, 300)
      })
    },
    getMinVer (state = '') {
      let params = {
        page_size: '100',
        page: '1',
        sort: 'updated_at desc',
        tvid: this.editId,
        query: state
      }
      https.request({
        method: 'get',
        url: '/v2/es/app/vers',
        params: params
      }).then(res => {
        this.minVerList = res.data.items
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    applyPayAlert (index) {
      if (this.userAccount.qualification_type === 2) {
        if (this.userAccount.qualification_status === 0 || this.userAccount.qualification_status === 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请先去资质审核',
            onOk: () => {
              this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else if (this.dataList[index].aduit_stats !== 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请去审核应用',
            onOk: () => {
              // this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else {
          // this.getStroePkgName(this.dataList[index].package_name)
          console.log(this.dataList, index)
          if (this.dataList[index].package_stats !== '线上版本') {
            this.$Modal.confirm({
              title: '提示',
              content: '请先去选择版本上线',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          if (this.dataList[index].store_pkg_name.length === 0) {
            this.$Modal.confirm({
              title: '提示',
              content: '请先在欢视商店提交上架',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          this.isShowApplyPay = true
          this.appPkgFlag = true
          this.formPayValidate = {
            app_pkg: this.dataList[index].package_name,
            apk_pkg: this.dataList[index].store_pkg_name,
            apk_name: this.dataList[index].store_app_name
          }
        }
      } else if (this.userAccount.qualification_type === 1) {
        if (this.userAccount.qualification_status === 0 || this.userAccount.qualification_status === 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请先去资质审核',
            onOk: () => {
              this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else if (this.dataList[index].aduit_stats !== 2) {
          this.$Modal.confirm({
            title: '提示',
            content: '请去审核应用',
            onOk: () => {
              // this.$router.push('certification')
            },
            onCancel: () => {
            }
          })
        } else {
          // this.getStroePkgName(this.dataList[index].package_name)
          console.log(this.dataList, index)
          if (this.dataList[index].package_stats !== '线上版本') {
            this.$Modal.confirm({
              title: '提示',
              content: '请先去选择版本上线',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          if (this.dataList[index].store_pkg_name.length === 0) {
            this.$Modal.confirm({
              title: '提示',
              content: '请先在欢视商店提交上架',
              onOk: () => {
                // this.$router.push('certification')
              },
              onCancel: () => {
              }
            })
            return
          }
          this.isShowApplyPay = true
          this.appPkgFlag = true
          this.formPayValidate = {
            apk_name: this.dataList[index].store_app_name,
            app_pkg: this.dataList[index].package_name,
            apk_pkg: this.dataList[index].store_pkg_name
          }
        }
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '请先去资质审核',
          onOk: () => {
            this.$router.push('certification')
          },
          onCancel: () => {
          }
        })
      }
    },
    getStroePkgName (id) {
      https.request({
        method: 'get',
        url: '/v2/es/app/storepkgname',
        params: {
          es_pkg_name: id
        }
      }).then(res => {
        if (res.data.store_pkg_name.length === 0) {
          this.appPkgFlag = false
        } else {
          this.appPkgFlag = true
          this.formPayValidate.apk_pkg = res.data.store_pkg_name
        }
      })
    },
    setTableType () {
      sessionStorage.setItem('tableType', this.tableType)
    },
    gotoScroll (item) {
      sessionStorage.setItem('scroll_top_apk', item.id)
      this.setTableType()
      this.$router.push({
        path: `/developer/versionTest`,
        query: {
          tvid: item.id,
          icon: item.icon,
          name: item.name,
          package_name: item.package_name,
          table: this.tableType,
          id: item.id,
          uid: item.uid
        }
      })
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchAppVer = ''
      this.loadData()
    },
    aduitText (val) {
      if (val === 0) {
        return '未提审'
      } else if (val === 1) {
        return '待审核'
      } else if (val === 2) {
        return '审核通过'
      } else if (val === 3) {
        return '审核驳回'
      }
    },
    changeUserId (val) {
      this.searchAppName = ''
      this.searchAppVer = ''
      this.loadData(val)
    },
    changeTableType (val) {
      this.dataList = []
      this.tableType = val
      this.current = 1
      this.setTableType()
      if (val === 0) {
        this.pageSize = 40
      } else {
        this.pageSize = 10
      }
      this.loadData()
    },
    clearUserId () {
      this.loadData()
    },
    getUserNameAuth () {
      let userNameAuth = sessionStorage.getItem('user_name_auth')
      if (userNameAuth !== null) {
        this.userList.map(item => {
          if (item.label === userNameAuth) {
            this.userInfoId = item.value
            this.loadData(item.value)
            sessionStorage.removeItem('user_name_auth')
          }
        })
      }
    },
    getUserList () {
      let params = {
        page_size: 200,
        page: 1
      }
      https.request({
        method: 'get',
        url: '/v1/account/',
        params: params
      }).then(res => {
        res.data.list.map(item => {
          this.userList.push({
            value: item.id,
            label: item.username
          })
        })
        this.getUserNameAuth()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 加载tabs列表
    loadData (type = 'no') {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        // uid: id,
        name: this.searchAppName,
        package_ver: this.searchAppVer
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        url: 'v2/es/apptest/list',
        params: params
      }).then(res => {
        this.tableLoading = false
        this.isShowSpin = false
        res.data.items.forEach(n => {
          if (n.state === 2) {
            n.app_status = '已禁用'
          } else if (n.aduit_stats === 1) {
            n.app_status = '应用待审核'
          } else if (n.aduit_stats === 3) {
            n.app_status = '审核未通过'
          } else if (n.aduit_stats === 2 && n.package_ver) {
            n.app_status = '已上线'
          }
        })
        res.data.items.forEach(n => {
          if (n.package_stats === 0) {
            n.package_stats = '未发布'
          } else if (n.package_stats === 1) {
            n.package_stats = '测试版本'
          } else if (n.package_stats === 2) {
            n.package_stats = '线上版本'
          } else if (n.package_stats === 3) {
            n.package_stats = '历史版本'
          }
        })
        if (this.tableType === 0) {
          if (type === 'no') {
            this.dataList = res.data.items
          } else {
            this.dataList = [...this.dataList, ...res.data.items]
          }
        } else {
          this.getUserNameFun(res.data.items)
        }
        // this.dataList = res.data.items
        this.total = res.data.total
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.uid)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (Number(item.value) === sItem.uid) {
              sItem['userName'] = item.text
            }
          })
        })
        // setTimeout(() => {
        this.dataList = list
        // }, 500)
      })
    },
    switchChange (val) {
      console.log(val)
      if (val) {
        this.formValidate.state = 1
        console.log(val)
      } else {
        this.formValidate.state = 2
      }
    },
    uploadImg (name) {
      let file = this.$refs[name].files[0]
      this.formValidate.files = file
      this.formValidate.fileName = file.name
    },
    delCurrentApp () {
      this.delItem(this.currentIndex)
      this.newdata = false
    },
    newAlert (index, type = 'edit') {
      this.$refs['formValidate'].resetFields()
      if (!isNaN(index)) {
        this.editId = this.dataList[index].id
        this.getMinVer()
        this.formValidate = {
          name: this.dataList[index].name,
          remark: this.dataList[index].remark,
          package_name: this.dataList[index].package_name,
          icon: this.dataList[index].icon,
          aduit_stats: this.dataList[index].aduit_stats,
          aduit_con: this.dataList[index].aduit_con,
          pre_pwd: this.dataList[index].pre_pwd,
          min_ver: this.dataList[index].min_ver,
          files: '',
          fileName: '',
          state: this.dataList[index].state,
          id: this.dataList[index].id
        }
        console.log(this.formValidate)
        this.editItem = this.dataList[index]
        this.editFlag = this.dataList[index].uid === this.userId ? type === 'edit' ? 'false' : 'true' : 'true'
        this.currentIndex = index
      } else {
        this.editId = ''
        this.editItem = ''
        this.formValidate.files = ''
        this.formValidate.icon = ''
        this.formValidate.aduit_stats = ''
        this.editFlag = 'false'
      }
      this.newdata = true
    },
    applyData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.userAccount.qualification_type === 1) {
            this.checkAgreement()
          } else if (this.userAccount.qualification_type === 2) {
            this.isShowAgreement = true
          }
        }
      })
    },
    checkAgreement () {
      https.request({
        method: 'post',
        url: '/v2/es/audit/payment',
        data: this.formPayValidate
      }).then(res => {
        console.log(res)
        if (res.code === 400) {
          if (res.message === '该小程序不属于当前账号, 无法提交申请') {
            this.$Message.error(res.message)
          } else {
            this.$Message.error(res.message)
          }
        }
        this.isShowAgreement = false
        this.isShowApplyPay = false
        this.single = false
        this.loadData()
        this.formPayValidate = {}
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    clearErrArr () {
      this.batchErrArrFlag = false
      this.batchErrArr = []
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = new FormData()
            params.append('name', this.formValidate.name)
            if (this.formValidate.fileName) params.append('icon', this.formValidate.files)
            if (this.formValidate.pre_pwd) params.append('pre_pwd', this.formValidate.pre_pwd)
            params.append('remark', this.formValidate.remark)
            if (this.editId) {
              params.append('status', this.formValidate.state)
              params.append('id', this.editId)
              params.append('min_ver', this.formValidate.min_ver)
              https.request({
                method: 'put',
                url: '/v2/es/apptest/put',
                data: params
              }).then(res => {
                console.log(res)
                if (res.code === 400) {
                  console.log(res.message)
                  this.$Message.error(res.message)
                  this.newdata = false
                  this.loadData()
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              params.append('package_name', this.trim(this.formValidate.package_name))
              https.request({
                method: 'post',
                url: '/v2/es/apptest/add',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                data: params
              }).then(res => {
                console.log(res)
                if (res.data && res.data.code === 400) {
                  this.$Message.error(res.data.msg)
                  return
                }
                this.$Message.success('提交成功')
                setTimeout(() => {
                  this.newdata = false
                  this.loadData()
                }, 1000)
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    trim (str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    delItem (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p class="del-modal-txt">确定要删除 <span>' + this.dataList[index].name + '</span> 吗？</p>',
        onOk: () => {
          if (this.dataList[index].is_sync) {
            this.$Message.error('同步小程序不可删除')
            return
          }
          https.request({
            method: 'GET',
            url: '/v2/es/apptest/del',
            params: {
              id: this.dataList[index].id
            }
          }).then(res => {
            if (res.data && res.data.code === 400) {
              this.$Message.error(res.data.msg)
              return
            }
            this.$Message.success('删除成功')
            if (this.dataList.length === 1 && this.current > 1) this.current -= 1
            this.loadData()
          }).catch(error => {
            this.$Message.error(error)
          })
        }
      })
    },
    getAccount () {
      // /v2/es/account
      https.request({
        method: 'GET',
        url: '/v2/es/account',
        params: {}
      }).then(res => {
        console.log(res)
        this.userAccount = res.data
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    copyStr (str) {
      console.log(str)
      const input = document.querySelector('#copyinput')
      input.value = str
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$Message.success('复制成功')
        // input.value = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:407px;
    // left:407px;
  }
  .input_left_two{
    left:580px;
    // left:580px;
  }
  .input_left_three{
    left:755px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/esAppTest/esAppTest.vue